module.exports = __webpack_public_path__ + "static/media/socialImage.8bd22129.png";